// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './formComponent';

/**
 * @class Button
 * @param  {string} options.text Button label text
 * @param  {function} options.onClick onClick handler
 * @param  {boolean} options.loading Display a loading indicator
 *
 * @example
 * new myw.Button({
 *   text: "Hello World",
 *   onClick: function() {},
 *   loading: true
 * })
 *
 * @extends {FormComponent}
 */
myw.Button = myw.FormComponent.extend({
    tagName: 'button',
    events: {
        click: '_onClick'
    },
    initialize(options) {
        myw.FormComponent.prototype.initialize.call(this, options);
        this.render(options);
    },

    render(options) {
        if (this.options.text) {
            this.$el.html(this.options.text);
        }

        if (this.options.loading) {
            this.$el.html('<img height="15px"src="images/searching.gif" />');
        }
        myw.FormComponent.prototype.render.call(this, options);
        return this;
    },

    _onClick(el) {
        const options = this.options;
        if (options.onClick) {
            options.onClick.call({}, this);
        }
    }
});

export default myw.Button;
